import { render, staticRenderFns } from "./FAQQuestion.vue?vue&type=template&id=3ed9d745&scoped=true&"
import script from "./FAQQuestion.vue?vue&type=script&lang=js&"
export * from "./FAQQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FAQQuestion.vue?vue&type=style&index=0&id=3ed9d745&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed9d745",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VIcon})
